
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as appoARvJ9pTIAlSwGNu9CDvfiuUETdLPDqEIX3DFwG66D0Meta } from "/app/pages/app.vue?macro=true";
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue?macro=true";
import { default as teamSEAvYegqaP9TQYa6utWHKYo3MYTiIT9JxlO2mrUHaccMeta } from "/app/pages/team.vue?macro=true";
import { default as aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue?macro=true";
import { default as iconsACypggH3XbVuzX6_skZLNRYYVYRvi3qIp6DlOX9zslgMeta } from "/app/pages/icons.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as pressmzF5P4tliElByO1nSgeAhr7mMfuH48Lrbqc9BlsZOzMMeta } from "/app/pages/press.vue?macro=true";
import { default as logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta } from "/app/pages/logout.vue?macro=true";
import { default as statusGxyJAiT6T08i4QnaacTYMdHkpZ5UFlYXwaNfFcltlQwMeta } from "/app/pages/status.vue?macro=true";
import { default as earndOO221bj4a3MSFkH4fCyBPj67NiX85qqbznli_45ICxnAMeta } from "/app/pages/account/earn.vue?macro=true";
import { default as indexKGFpJrfaPGuuhppiHh6jzgX1cc0MaKSlIxKJ_45q3hxrYMeta } from "/app/pages/account/index.vue?macro=true";
import { default as invitehvxsAdJ2XsHtnwbBFlcSWl_450l8kJNb5yW0J27_jIMjIMeta } from "/app/pages/account/invite.vue?macro=true";
import { default as billingkONIQ_71Qe_3Am3ZQzm138PjIpPnqkA0oCO4nRPNfqgMeta } from "/app/pages/account/billing.vue?macro=true";
import { default as paymentoYx18cuDu7t92WHX6G_45UgQYiPUYXZewuJR71k_dSu28Meta } from "/app/pages/account/payment.vue?macro=true";
import { default as payoutsk_45P3ZU5sxP_jTdfxyVBlI2sEUMl1KPGwS2lkM9jLq68Meta } from "/app/pages/account/payouts.vue?macro=true";
import { default as rewardsPLGLLNDl8x9Zp0PO__Ev60UJ6nsqFcOp70QeHgCoM7QMeta } from "/app/pages/account/rewards.vue?macro=true";
import { default as missionsDdSxJT79aGeW9TSFxHgz1MNCfs_vMSn0GKDtNMC7YSIMeta } from "/app/pages/account/missions.vue?macro=true";
import { default as my_45games3ya_45WTjbAM6i7sYIngUnqnLTQm_2fef0shmebPi1Z2oMeta } from "/app/pages/account/my-games.vue?macro=true";
import { default as dashboardtK0ozZhMYhXnncQ3sPTlwjI3OZxF0srgQvD0oGApcOQMeta } from "/app/pages/account/dashboard.vue?macro=true";
import { default as affiliatesfQou0CY9rdso910vyF_45hyWoH76LmIb0_45S8q9MIVpGGEMeta } from "/app/pages/account/affiliates.vue?macro=true";
import { default as preferencesfsNnEVD_45EuGddALCIm2HkTP3j_LCZbfnHkN6BQrN7wAMeta } from "/app/pages/account/preferences.vue?macro=true";
import { default as newfjaVBeKSdL1rBrFlS6gpNge_45cy8L_450SNTx_45fYbsenj4Meta } from "/app/pages/account/support/new.vue?macro=true";
import { default as my_45companiesJphMXbR_45clBz_45O9xdweQs9c0bH1OuiK83A1Qu1y5yaQMeta } from "/app/pages/account/my-companies.vue?macro=true";
import { default as indexe7s7eq6Gqw13eyJpKUg5drkdq8MUt_23Id35rwvO82EMeta } from "/app/pages/account/support/index.vue?macro=true";
import { default as _91uuid_93IUsjTC6eJtRrzSgnHs6xUBBTKya2RFnMfENNobLOrKUMeta } from "/app/pages/account/support/[uuid].vue?macro=true";
import { default as personal_45informations3J9AEwz7eP7ECQQeODqm6bzR70OVLy9_BFf_ZiF_45IE8Meta } from "/app/pages/account/personal-informations.vue?macro=true";
import { default as account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta } from "/app/pages/account.vue?macro=true";
import { default as careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as paymentdmPKSezhI6Ls0DyrYS8MHdT52WOZHA7vPz_458rflmGnUMeta } from "/app/pages/payment.vue?macro=true";
import { default as roadmapowPyo9n3RN50uA3cSAJhowP_45qy7NDqncrj8osXyeQ_45YMeta } from "/app/pages/roadmap.vue?macro=true";
import { default as partnerss9lBfNyvWm1ArfVYDNYaTZPixnScXy82e9acLeU4NuYMeta } from "/app/pages/partners.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as impressum3zzQy_454eQIfFpJ0LzE7oAVVZr5GATwT7mh6WVc9V9esMeta } from "/app/pages/impressum.vue?macro=true";
import { default as indexTKZ2jYK_R7WS22tyA1OvhMlcLkdFGgYZi_VAcjBjJr0Meta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue?macro=true";
import { default as indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue?macro=true";
import { default as health_45checkTDOGF5hME2LxxnjskOBL73S8fhlS81uO85Z_457OrMDPgMeta } from "/app/pages/health-check.vue?macro=true";
import { default as email_45verifiedwjdFD2sen3x5vS2zxLwNxrNygS7A7NNwvVgGdntqqqwMeta } from "/app/pages/email-verified.vue?macro=true";
import { default as indexhRQ7GWZenkFhVERKBJqlOt2f17aSEVe8KA2tGcsbJgcMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue?macro=true";
import { default as callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta } from "/app/pages/oauth/callback.vue?macro=true";
import { default as create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta } from "/app/pages/create-password.vue?macro=true";
import { default as indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue?macro=true";
import { default as _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue?macro=true";
import { default as _91slug_93ek9nNFkDM34o5BhMy23i9LKDDLrZK_u3OQTRGYq8nn4Meta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue?macro=true";
import { default as _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue?macro=true";
import { default as _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue?macro=true";
import { default as password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta } from "/app/pages/password-recovery.vue?macro=true";
import { default as indexYkTMtLQnT67wr_wb0419ZMbi7_45BDvy8z_45BZhEBcSTaAMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue?macro=true";
import { default as whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue?macro=true";
import { default as index3948xYM_45cUz2d4N_45dvMKq_45F4lKPTdfqr65TQJZMh5_45wMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue?macro=true";
import { default as qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta } from "/app/pages/qa-sidebar-preview.vue?macro=true";
import { default as indexyu5QYF5JhmVyV3wmoDTzBLg_45mQ4M9UN2JDlgxiMrL2IMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue?macro=true";
import { default as indexRLxGVqMRR7SwK2IU__mQEhYLcotJnGct9SP73TwjzywMeta } from "/app/pages/create-company/index.vue?macro=true";
import { default as _91slug_93ZjTx1Riz_45hqbe_8WyxL3kB_45fUtXbKOiR7iOM0_HIGfIMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue?macro=true";
import { default as _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue?macro=true";
import { default as indexk6xxi0O_45naywziHzTOKYMhArEbDL8BmcgFN_45sDzP048Meta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue?macro=true";
import { default as _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue?macro=true";
import { default as _91token_93IaXc0easaPe5psM71F9qPRbhIV_w8BjDEPnSfuS4zSoMeta } from "/app/pages/esignature/sign/[token].vue?macro=true";
import { default as preview2_45enGGinDWsiN0lpWEcw8K_45S_jMbH4qgVPofcIsbWDAMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue?macro=true";
import { default as redeem_45key73_45TlnnMfR_vK8SpSHQ_451aLDCezfCzoyuzZNUMFxQpwMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue?macro=true";
import { default as _91uuid_93Exu3umqFGrWqxYOjh8tQQsfg3OLxg_45sf0w7Ue_45JQN8sMeta } from "/app/pages/newsletter/manage/[uuid].vue?macro=true";
import { default as key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue?macro=true";
import { default as redeem_45key_45approved122slp2DGvrqkeiphLNh2IxUojLpEP9qcAt7PlCCPdMMeta } from "/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue?macro=true";
import { default as _91verificationId_93xNFpm5rO88UDQyfmfTX9R8R5v9ub14DePddd562PVPcMeta } from "/app/pages/esignature/verify/[verificationId].vue?macro=true";
export default [
  {
    name: "app___en___default",
    path: "/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___en",
    path: "/en/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___pt-BR",
    path: "/pt-BR/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___de",
    path: "/de/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___es",
    path: "/es/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___ro",
    path: "/ro/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "app___ar-AE",
    path: "/ar-AE/app",
    component: () => import("/app/pages/app.vue")
  },
  {
    name: "faq___en___default",
    path: "/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___en",
    path: "/en/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___pt-BR",
    path: "/pt-BR/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___de",
    path: "/de/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___es",
    path: "/es/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ro",
    path: "/ro/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "faq___ar-AE",
    path: "/ar-AE/faq",
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "blog___en___default",
    path: "/blog",
    meta: bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    meta: bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue")
  },
  {
    name: "blog___pt-BR",
    path: "/pt-BR/blog",
    meta: bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    meta: bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    meta: bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue")
  },
  {
    name: "blog___ro",
    path: "/ro/blog",
    meta: bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue")
  },
  {
    name: "blog___ar-AE",
    path: "/ar-AE/blog",
    meta: bloguzNKeMBxiY01jvchw79MKXwSAYm1WqpbjvMleyacfgMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/blog.vue")
  },
  {
    name: "team___en___default",
    path: "/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "team___en",
    path: "/en/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "team___pt-BR",
    path: "/pt-BR/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "team___de",
    path: "/de/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "team___es",
    path: "/es/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "team___ro",
    path: "/ro/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "team___ar-AE",
    path: "/ar-AE/team",
    component: () => import("/app/pages/team.vue")
  },
  {
    name: "about___en___default",
    path: "/about",
    meta: aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue")
  },
  {
    name: "about___en",
    path: "/en/about",
    meta: aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue")
  },
  {
    name: "about___pt-BR",
    path: "/pt-BR/about",
    meta: aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue")
  },
  {
    name: "about___de",
    path: "/de/about",
    meta: aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue")
  },
  {
    name: "about___es",
    path: "/es/about",
    meta: aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue")
  },
  {
    name: "about___ro",
    path: "/ro/about",
    meta: aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue")
  },
  {
    name: "about___ar-AE",
    path: "/ar-AE/about",
    meta: aboutwwgLE8BjfiyOszW69fo9177s5jELONXS_EeDb8S0RQ0Meta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/about.vue")
  },
  {
    name: "icons___en___default",
    path: "/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "icons___en",
    path: "/en/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "icons___pt-BR",
    path: "/pt-BR/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "icons___de",
    path: "/de/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "icons___es",
    path: "/es/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "icons___ro",
    path: "/ro/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "icons___ar-AE",
    path: "/ar-AE/icons",
    component: () => import("/app/pages/icons.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pt-BR",
    path: "/pt-BR",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ro",
    path: "/ro",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___ar-AE",
    path: "/ar-AE",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___pt-BR",
    path: "/pt-BR/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ro",
    path: "/ro/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "login___ar-AE",
    path: "/ar-AE/login",
    meta: { ...(loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "press___en___default",
    path: "/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "press___en",
    path: "/en/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "press___pt-BR",
    path: "/pt-BR/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "press___de",
    path: "/de/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "press___es",
    path: "/es/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "press___ro",
    path: "/ro/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "press___ar-AE",
    path: "/ar-AE/press",
    component: () => import("/app/pages/press.vue")
  },
  {
    name: "logout___en___default",
    path: "/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "logout___en",
    path: "/en/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "logout___pt-BR",
    path: "/pt-BR/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "logout___de",
    path: "/de/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "logout___es",
    path: "/es/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "logout___ro",
    path: "/ro/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "logout___ar-AE",
    path: "/ar-AE/logout",
    meta: logoutUcooZuBFq6Y_45qkSHe3Slgw7Ozl4rsMv5kY96MDZ8icoMeta || {},
    component: () => import("/app/pages/logout.vue")
  },
  {
    name: "status___en___default",
    path: "/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "status___en",
    path: "/en/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "status___pt-BR",
    path: "/pt-BR/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "status___de",
    path: "/de/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "status___es",
    path: "/es/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "status___ro",
    path: "/ro/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: "status___ar-AE",
    path: "/ar-AE/status",
    component: () => import("/app/pages/status.vue")
  },
  {
    name: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta?.name,
    path: "/account",
    meta: {"middleware":["auth-middleware","requires-password-confirmation"]},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-earn___en___default",
    path: "earn",
    component: () => import("/app/pages/account/earn.vue")
  },
  {
    name: "account___en___default",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-invite___en___default",
    path: "invite",
    component: () => import("/app/pages/account/invite.vue")
  },
  {
    name: "account-billing___en___default",
    path: "billing",
    component: () => import("/app/pages/account/billing.vue")
  },
  {
    name: "account-payment___en___default",
    path: "payment",
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payouts___en___default",
    path: "payouts",
    component: () => import("/app/pages/account/payouts.vue")
  },
  {
    name: "account-rewards___en___default",
    path: "rewards",
    component: () => import("/app/pages/account/rewards.vue")
  },
  {
    name: "account-missions___en___default",
    path: "missions",
    component: () => import("/app/pages/account/missions.vue")
  },
  {
    name: "account-my-games___en___default",
    path: "my-games",
    component: () => import("/app/pages/account/my-games.vue")
  },
  {
    name: "account-dashboard___en___default",
    path: "dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "account-affiliates___en___default",
    path: "affiliates",
    component: () => import("/app/pages/account/affiliates.vue")
  },
  {
    name: "account-preferences___en___default",
    path: "preferences",
    component: () => import("/app/pages/account/preferences.vue")
  },
  {
    name: "account-support-new___en___default",
    path: "support/new",
    component: () => import("/app/pages/account/support/new.vue")
  },
  {
    name: "account-my-companies___en___default",
    path: "my-companies",
    component: () => import("/app/pages/account/my-companies.vue")
  },
  {
    name: "account-support___en___default",
    path: "support",
    component: () => import("/app/pages/account/support/index.vue")
  },
  {
    name: "account-support-uuid___en___default",
    path: "support/:uuid()",
    component: () => import("/app/pages/account/support/[uuid].vue")
  },
  {
    name: "account-personal-informations___en___default",
    path: "personal-informations",
    component: () => import("/app/pages/account/personal-informations.vue")
  }
]
  },
  {
    name: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta?.name,
    path: "/en/account",
    meta: {"middleware":["auth-middleware","requires-password-confirmation"]},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-earn___en",
    path: "earn",
    component: () => import("/app/pages/account/earn.vue")
  },
  {
    name: "account___en",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-invite___en",
    path: "invite",
    component: () => import("/app/pages/account/invite.vue")
  },
  {
    name: "account-billing___en",
    path: "billing",
    component: () => import("/app/pages/account/billing.vue")
  },
  {
    name: "account-payment___en",
    path: "payment",
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payouts___en",
    path: "payouts",
    component: () => import("/app/pages/account/payouts.vue")
  },
  {
    name: "account-rewards___en",
    path: "rewards",
    component: () => import("/app/pages/account/rewards.vue")
  },
  {
    name: "account-missions___en",
    path: "missions",
    component: () => import("/app/pages/account/missions.vue")
  },
  {
    name: "account-my-games___en",
    path: "my-games",
    component: () => import("/app/pages/account/my-games.vue")
  },
  {
    name: "account-dashboard___en",
    path: "dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "account-affiliates___en",
    path: "affiliates",
    component: () => import("/app/pages/account/affiliates.vue")
  },
  {
    name: "account-preferences___en",
    path: "preferences",
    component: () => import("/app/pages/account/preferences.vue")
  },
  {
    name: "account-support-new___en",
    path: "support/new",
    component: () => import("/app/pages/account/support/new.vue")
  },
  {
    name: "account-my-companies___en",
    path: "my-companies",
    component: () => import("/app/pages/account/my-companies.vue")
  },
  {
    name: "account-support___en",
    path: "support",
    component: () => import("/app/pages/account/support/index.vue")
  },
  {
    name: "account-support-uuid___en",
    path: "support/:uuid()",
    component: () => import("/app/pages/account/support/[uuid].vue")
  },
  {
    name: "account-personal-informations___en",
    path: "personal-informations",
    component: () => import("/app/pages/account/personal-informations.vue")
  }
]
  },
  {
    name: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta?.name,
    path: "/pt-BR/account",
    meta: {"middleware":["auth-middleware","requires-password-confirmation"]},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-earn___pt-BR",
    path: "earn",
    component: () => import("/app/pages/account/earn.vue")
  },
  {
    name: "account___pt-BR",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-invite___pt-BR",
    path: "invite",
    component: () => import("/app/pages/account/invite.vue")
  },
  {
    name: "account-billing___pt-BR",
    path: "billing",
    component: () => import("/app/pages/account/billing.vue")
  },
  {
    name: "account-payment___pt-BR",
    path: "payment",
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payouts___pt-BR",
    path: "payouts",
    component: () => import("/app/pages/account/payouts.vue")
  },
  {
    name: "account-rewards___pt-BR",
    path: "rewards",
    component: () => import("/app/pages/account/rewards.vue")
  },
  {
    name: "account-missions___pt-BR",
    path: "missions",
    component: () => import("/app/pages/account/missions.vue")
  },
  {
    name: "account-my-games___pt-BR",
    path: "my-games",
    component: () => import("/app/pages/account/my-games.vue")
  },
  {
    name: "account-dashboard___pt-BR",
    path: "dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "account-affiliates___pt-BR",
    path: "affiliates",
    component: () => import("/app/pages/account/affiliates.vue")
  },
  {
    name: "account-preferences___pt-BR",
    path: "preferences",
    component: () => import("/app/pages/account/preferences.vue")
  },
  {
    name: "account-support-new___pt-BR",
    path: "support/new",
    component: () => import("/app/pages/account/support/new.vue")
  },
  {
    name: "account-my-companies___pt-BR",
    path: "my-companies",
    component: () => import("/app/pages/account/my-companies.vue")
  },
  {
    name: "account-support___pt-BR",
    path: "support",
    component: () => import("/app/pages/account/support/index.vue")
  },
  {
    name: "account-support-uuid___pt-BR",
    path: "support/:uuid()",
    component: () => import("/app/pages/account/support/[uuid].vue")
  },
  {
    name: "account-personal-informations___pt-BR",
    path: "personal-informations",
    component: () => import("/app/pages/account/personal-informations.vue")
  }
]
  },
  {
    name: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta?.name,
    path: "/de/account",
    meta: {"middleware":["auth-middleware","requires-password-confirmation"]},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-earn___de",
    path: "earn",
    component: () => import("/app/pages/account/earn.vue")
  },
  {
    name: "account___de",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-invite___de",
    path: "invite",
    component: () => import("/app/pages/account/invite.vue")
  },
  {
    name: "account-billing___de",
    path: "billing",
    component: () => import("/app/pages/account/billing.vue")
  },
  {
    name: "account-payment___de",
    path: "payment",
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payouts___de",
    path: "payouts",
    component: () => import("/app/pages/account/payouts.vue")
  },
  {
    name: "account-rewards___de",
    path: "rewards",
    component: () => import("/app/pages/account/rewards.vue")
  },
  {
    name: "account-missions___de",
    path: "missions",
    component: () => import("/app/pages/account/missions.vue")
  },
  {
    name: "account-my-games___de",
    path: "my-games",
    component: () => import("/app/pages/account/my-games.vue")
  },
  {
    name: "account-dashboard___de",
    path: "dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "account-affiliates___de",
    path: "affiliates",
    component: () => import("/app/pages/account/affiliates.vue")
  },
  {
    name: "account-preferences___de",
    path: "preferences",
    component: () => import("/app/pages/account/preferences.vue")
  },
  {
    name: "account-support-new___de",
    path: "support/new",
    component: () => import("/app/pages/account/support/new.vue")
  },
  {
    name: "account-my-companies___de",
    path: "my-companies",
    component: () => import("/app/pages/account/my-companies.vue")
  },
  {
    name: "account-support___de",
    path: "support",
    component: () => import("/app/pages/account/support/index.vue")
  },
  {
    name: "account-support-uuid___de",
    path: "support/:uuid()",
    component: () => import("/app/pages/account/support/[uuid].vue")
  },
  {
    name: "account-personal-informations___de",
    path: "personal-informations",
    component: () => import("/app/pages/account/personal-informations.vue")
  }
]
  },
  {
    name: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta?.name,
    path: "/es/account",
    meta: {"middleware":["auth-middleware","requires-password-confirmation"]},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-earn___es",
    path: "earn",
    component: () => import("/app/pages/account/earn.vue")
  },
  {
    name: "account___es",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-invite___es",
    path: "invite",
    component: () => import("/app/pages/account/invite.vue")
  },
  {
    name: "account-billing___es",
    path: "billing",
    component: () => import("/app/pages/account/billing.vue")
  },
  {
    name: "account-payment___es",
    path: "payment",
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payouts___es",
    path: "payouts",
    component: () => import("/app/pages/account/payouts.vue")
  },
  {
    name: "account-rewards___es",
    path: "rewards",
    component: () => import("/app/pages/account/rewards.vue")
  },
  {
    name: "account-missions___es",
    path: "missions",
    component: () => import("/app/pages/account/missions.vue")
  },
  {
    name: "account-my-games___es",
    path: "my-games",
    component: () => import("/app/pages/account/my-games.vue")
  },
  {
    name: "account-dashboard___es",
    path: "dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "account-affiliates___es",
    path: "affiliates",
    component: () => import("/app/pages/account/affiliates.vue")
  },
  {
    name: "account-preferences___es",
    path: "preferences",
    component: () => import("/app/pages/account/preferences.vue")
  },
  {
    name: "account-support-new___es",
    path: "support/new",
    component: () => import("/app/pages/account/support/new.vue")
  },
  {
    name: "account-my-companies___es",
    path: "my-companies",
    component: () => import("/app/pages/account/my-companies.vue")
  },
  {
    name: "account-support___es",
    path: "support",
    component: () => import("/app/pages/account/support/index.vue")
  },
  {
    name: "account-support-uuid___es",
    path: "support/:uuid()",
    component: () => import("/app/pages/account/support/[uuid].vue")
  },
  {
    name: "account-personal-informations___es",
    path: "personal-informations",
    component: () => import("/app/pages/account/personal-informations.vue")
  }
]
  },
  {
    name: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta?.name,
    path: "/ro/account",
    meta: {"middleware":["auth-middleware","requires-password-confirmation"]},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-earn___ro",
    path: "earn",
    component: () => import("/app/pages/account/earn.vue")
  },
  {
    name: "account___ro",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-invite___ro",
    path: "invite",
    component: () => import("/app/pages/account/invite.vue")
  },
  {
    name: "account-billing___ro",
    path: "billing",
    component: () => import("/app/pages/account/billing.vue")
  },
  {
    name: "account-payment___ro",
    path: "payment",
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payouts___ro",
    path: "payouts",
    component: () => import("/app/pages/account/payouts.vue")
  },
  {
    name: "account-rewards___ro",
    path: "rewards",
    component: () => import("/app/pages/account/rewards.vue")
  },
  {
    name: "account-missions___ro",
    path: "missions",
    component: () => import("/app/pages/account/missions.vue")
  },
  {
    name: "account-my-games___ro",
    path: "my-games",
    component: () => import("/app/pages/account/my-games.vue")
  },
  {
    name: "account-dashboard___ro",
    path: "dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "account-affiliates___ro",
    path: "affiliates",
    component: () => import("/app/pages/account/affiliates.vue")
  },
  {
    name: "account-preferences___ro",
    path: "preferences",
    component: () => import("/app/pages/account/preferences.vue")
  },
  {
    name: "account-support-new___ro",
    path: "support/new",
    component: () => import("/app/pages/account/support/new.vue")
  },
  {
    name: "account-my-companies___ro",
    path: "my-companies",
    component: () => import("/app/pages/account/my-companies.vue")
  },
  {
    name: "account-support___ro",
    path: "support",
    component: () => import("/app/pages/account/support/index.vue")
  },
  {
    name: "account-support-uuid___ro",
    path: "support/:uuid()",
    component: () => import("/app/pages/account/support/[uuid].vue")
  },
  {
    name: "account-personal-informations___ro",
    path: "personal-informations",
    component: () => import("/app/pages/account/personal-informations.vue")
  }
]
  },
  {
    name: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta?.name,
    path: "/ar-AE/account",
    meta: {"middleware":["auth-middleware","requires-password-confirmation"]},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-earn___ar-AE",
    path: "earn",
    component: () => import("/app/pages/account/earn.vue")
  },
  {
    name: "account___ar-AE",
    path: "",
    component: () => import("/app/pages/account/index.vue")
  },
  {
    name: "account-invite___ar-AE",
    path: "invite",
    component: () => import("/app/pages/account/invite.vue")
  },
  {
    name: "account-billing___ar-AE",
    path: "billing",
    component: () => import("/app/pages/account/billing.vue")
  },
  {
    name: "account-payment___ar-AE",
    path: "payment",
    component: () => import("/app/pages/account/payment.vue")
  },
  {
    name: "account-payouts___ar-AE",
    path: "payouts",
    component: () => import("/app/pages/account/payouts.vue")
  },
  {
    name: "account-rewards___ar-AE",
    path: "rewards",
    component: () => import("/app/pages/account/rewards.vue")
  },
  {
    name: "account-missions___ar-AE",
    path: "missions",
    component: () => import("/app/pages/account/missions.vue")
  },
  {
    name: "account-my-games___ar-AE",
    path: "my-games",
    component: () => import("/app/pages/account/my-games.vue")
  },
  {
    name: "account-dashboard___ar-AE",
    path: "dashboard",
    component: () => import("/app/pages/account/dashboard.vue")
  },
  {
    name: "account-affiliates___ar-AE",
    path: "affiliates",
    component: () => import("/app/pages/account/affiliates.vue")
  },
  {
    name: "account-preferences___ar-AE",
    path: "preferences",
    component: () => import("/app/pages/account/preferences.vue")
  },
  {
    name: "account-support-new___ar-AE",
    path: "support/new",
    component: () => import("/app/pages/account/support/new.vue")
  },
  {
    name: "account-my-companies___ar-AE",
    path: "my-companies",
    component: () => import("/app/pages/account/my-companies.vue")
  },
  {
    name: "account-support___ar-AE",
    path: "support",
    component: () => import("/app/pages/account/support/index.vue")
  },
  {
    name: "account-support-uuid___ar-AE",
    path: "support/:uuid()",
    component: () => import("/app/pages/account/support/[uuid].vue")
  },
  {
    name: "account-personal-informations___ar-AE",
    path: "personal-informations",
    component: () => import("/app/pages/account/personal-informations.vue")
  }
]
  },
  {
    name: "careers___en___default",
    path: "/careers",
    meta: careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue")
  },
  {
    name: "careers___en",
    path: "/en/careers",
    meta: careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue")
  },
  {
    name: "careers___pt-BR",
    path: "/pt-BR/careers",
    meta: careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue")
  },
  {
    name: "careers___de",
    path: "/de/careers",
    meta: careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue")
  },
  {
    name: "careers___es",
    path: "/es/careers",
    meta: careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue")
  },
  {
    name: "careers___ro",
    path: "/ro/careers",
    meta: careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue")
  },
  {
    name: "careers___ar-AE",
    path: "/ar-AE/careers",
    meta: careersxB2fXZ82Vthd2MpWYxxz4dmwgGkvB4dHjFyVOIGDjUkMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/careers.vue")
  },
  {
    name: "contact___en___default",
    path: "/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___pt-BR",
    path: "/pt-BR/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ro",
    path: "/ro/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "contact___ar-AE",
    path: "/ar-AE/contact",
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "payment___en___default",
    path: "/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "payment___en",
    path: "/en/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "payment___pt-BR",
    path: "/pt-BR/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "payment___de",
    path: "/de/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "payment___es",
    path: "/es/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "payment___ro",
    path: "/ro/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "payment___ar-AE",
    path: "/ar-AE/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "roadmap___en___default",
    path: "/roadmap",
    component: () => import("/app/pages/roadmap.vue")
  },
  {
    name: "roadmap___en",
    path: "/en/roadmap",
    component: () => import("/app/pages/roadmap.vue")
  },
  {
    name: "roadmap___pt-BR",
    path: "/pt-BR/roadmap",
    component: () => import("/app/pages/roadmap.vue")
  },
  {
    name: "roadmap___de",
    path: "/de/roadmap",
    component: () => import("/app/pages/roadmap.vue")
  },
  {
    name: "roadmap___es",
    path: "/es/roadmap",
    component: () => import("/app/pages/roadmap.vue")
  },
  {
    name: "roadmap___ro",
    path: "/ro/roadmap",
    component: () => import("/app/pages/roadmap.vue")
  },
  {
    name: "roadmap___ar-AE",
    path: "/ar-AE/roadmap",
    component: () => import("/app/pages/roadmap.vue")
  },
  {
    name: "partners___en___default",
    path: "/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___en",
    path: "/en/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___pt-BR",
    path: "/pt-BR/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___de",
    path: "/de/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___es",
    path: "/es/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___ro",
    path: "/ro/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "partners___ar-AE",
    path: "/ar-AE/partners",
    component: () => import("/app/pages/partners.vue")
  },
  {
    name: "register___en___default",
    path: "/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___pt-BR",
    path: "/pt-BR/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___ro",
    path: "/ro/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "register___ar-AE",
    path: "/ar-AE/register",
    meta: { ...(registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "impressum___en___default",
    path: "/impressum",
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "impressum___en",
    path: "/en/impressum",
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "impressum___pt-BR",
    path: "/pt-BR/impressum",
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "impressum___de",
    path: "/de/impressum",
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "impressum___es",
    path: "/es/impressum",
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "impressum___ro",
    path: "/ro/impressum",
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "impressum___ar-AE",
    path: "/ar-AE/impressum",
    component: () => import("/app/pages/impressum.vue")
  },
  {
    name: "keys___en___default",
    path: "/keys",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue")
  },
  {
    name: "keys___en",
    path: "/en/keys",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue")
  },
  {
    name: "keys___pt-BR",
    path: "/pt-BR/keys",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue")
  },
  {
    name: "keys___de",
    path: "/de/keys",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue")
  },
  {
    name: "keys___es",
    path: "/es/keys",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue")
  },
  {
    name: "keys___ro",
    path: "/ro/keys",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue")
  },
  {
    name: "keys___ar-AE",
    path: "/ar-AE/keys",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/keys/index.vue")
  },
  {
    name: "slug___en___default",
    path: "/:slug()",
    meta: indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug()",
    meta: indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue")
  },
  {
    name: "slug___pt-BR",
    path: "/pt-BR/:slug()",
    meta: indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug()",
    meta: indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug()",
    meta: indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue")
  },
  {
    name: "slug___ro",
    path: "/ro/:slug()",
    meta: indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue")
  },
  {
    name: "slug___ar-AE",
    path: "/ar-AE/:slug()",
    meta: indexKaDd3_45pfWGFypM59_451tEf65vLIXGmqOCnJBcIU0oZuEMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/[slug]/index.vue")
  },
  {
    name: "health-check___en___default",
    path: "/health-check",
    component: () => import("/app/pages/health-check.vue")
  },
  {
    name: "health-check___en",
    path: "/en/health-check",
    component: () => import("/app/pages/health-check.vue")
  },
  {
    name: "health-check___pt-BR",
    path: "/pt-BR/health-check",
    component: () => import("/app/pages/health-check.vue")
  },
  {
    name: "health-check___de",
    path: "/de/health-check",
    component: () => import("/app/pages/health-check.vue")
  },
  {
    name: "health-check___es",
    path: "/es/health-check",
    component: () => import("/app/pages/health-check.vue")
  },
  {
    name: "health-check___ro",
    path: "/ro/health-check",
    component: () => import("/app/pages/health-check.vue")
  },
  {
    name: "health-check___ar-AE",
    path: "/ar-AE/health-check",
    component: () => import("/app/pages/health-check.vue")
  },
  {
    name: "email-verified___en___default",
    path: "/email-verified",
    component: () => import("/app/pages/email-verified.vue")
  },
  {
    name: "email-verified___en",
    path: "/en/email-verified",
    component: () => import("/app/pages/email-verified.vue")
  },
  {
    name: "email-verified___pt-BR",
    path: "/pt-BR/email-verified",
    component: () => import("/app/pages/email-verified.vue")
  },
  {
    name: "email-verified___de",
    path: "/de/email-verified",
    component: () => import("/app/pages/email-verified.vue")
  },
  {
    name: "email-verified___es",
    path: "/es/email-verified",
    component: () => import("/app/pages/email-verified.vue")
  },
  {
    name: "email-verified___ro",
    path: "/ro/email-verified",
    component: () => import("/app/pages/email-verified.vue")
  },
  {
    name: "email-verified___ar-AE",
    path: "/ar-AE/email-verified",
    component: () => import("/app/pages/email-verified.vue")
  },
  {
    name: "magazine___en___default",
    path: "/magazine",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue")
  },
  {
    name: "magazine___en",
    path: "/en/magazine",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue")
  },
  {
    name: "magazine___pt-BR",
    path: "/pt-BR/magazine",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue")
  },
  {
    name: "magazine___de",
    path: "/de/magazine",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue")
  },
  {
    name: "magazine___es",
    path: "/es/magazine",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue")
  },
  {
    name: "magazine___ro",
    path: "/ro/magazine",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue")
  },
  {
    name: "magazine___ar-AE",
    path: "/ar-AE/magazine",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/index.vue")
  },
  {
    name: "oauth-callback___en___default",
    path: "/oauth/callback",
    meta: callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta || {},
    component: () => import("/app/pages/oauth/callback.vue")
  },
  {
    name: "oauth-callback___en",
    path: "/en/oauth/callback",
    meta: callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta || {},
    component: () => import("/app/pages/oauth/callback.vue")
  },
  {
    name: "oauth-callback___pt-BR",
    path: "/pt-BR/oauth/callback",
    meta: callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta || {},
    component: () => import("/app/pages/oauth/callback.vue")
  },
  {
    name: "oauth-callback___de",
    path: "/de/oauth/callback",
    meta: callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta || {},
    component: () => import("/app/pages/oauth/callback.vue")
  },
  {
    name: "oauth-callback___es",
    path: "/es/oauth/callback",
    meta: callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta || {},
    component: () => import("/app/pages/oauth/callback.vue")
  },
  {
    name: "oauth-callback___ro",
    path: "/ro/oauth/callback",
    meta: callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta || {},
    component: () => import("/app/pages/oauth/callback.vue")
  },
  {
    name: "oauth-callback___ar-AE",
    path: "/ar-AE/oauth/callback",
    meta: callbackUxdY7fvVbLCjIpvy3cBfDRo85xIUqjzrvwK7RNBBAn8Meta || {},
    component: () => import("/app/pages/oauth/callback.vue")
  },
  {
    name: "create-password___en___default",
    path: "/create-password",
    meta: { ...(create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/create-password.vue")
  },
  {
    name: "create-password___en",
    path: "/en/create-password",
    meta: { ...(create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/create-password.vue")
  },
  {
    name: "create-password___pt-BR",
    path: "/pt-BR/create-password",
    meta: { ...(create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/create-password.vue")
  },
  {
    name: "create-password___de",
    path: "/de/create-password",
    meta: { ...(create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/create-password.vue")
  },
  {
    name: "create-password___es",
    path: "/es/create-password",
    meta: { ...(create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/create-password.vue")
  },
  {
    name: "create-password___ro",
    path: "/ro/create-password",
    meta: { ...(create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/create-password.vue")
  },
  {
    name: "create-password___ar-AE",
    path: "/ar-AE/create-password",
    meta: { ...(create_45passwordni4yrq8FglTI3BUY2HG8S9vN1NgTZgP4u5LE9EyBfOEMeta || {}), ...{"middleware":"guest-middleware"} },
    component: () => import("/app/pages/create-password.vue")
  },
  {
    name: "press-kit___en___default",
    path: "/press-kit",
    meta: indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue")
  },
  {
    name: "press-kit___en",
    path: "/en/press-kit",
    meta: indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue")
  },
  {
    name: "press-kit___pt-BR",
    path: "/pt-BR/press-kit",
    meta: indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue")
  },
  {
    name: "press-kit___de",
    path: "/de/press-kit",
    meta: indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue")
  },
  {
    name: "press-kit___es",
    path: "/es/press-kit",
    meta: indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue")
  },
  {
    name: "press-kit___ro",
    path: "/ro/press-kit",
    meta: indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue")
  },
  {
    name: "press-kit___ar-AE",
    path: "/ar-AE/press-kit",
    meta: indexwn480dxpDIrFX1tPjYqjNLSEpJkL_cMKm8YQGSXUWKgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/index.vue")
  },
  {
    name: "presskit-slug___en___default",
    path: "/presskit/:slug()",
    meta: _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue")
  },
  {
    name: "presskit-slug___en",
    path: "/en/presskit/:slug()",
    meta: _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue")
  },
  {
    name: "presskit-slug___pt-BR",
    path: "/pt-BR/presskit/:slug()",
    meta: _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue")
  },
  {
    name: "presskit-slug___de",
    path: "/de/presskit/:slug()",
    meta: _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue")
  },
  {
    name: "presskit-slug___es",
    path: "/es/presskit/:slug()",
    meta: _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue")
  },
  {
    name: "presskit-slug___ro",
    path: "/ro/presskit/:slug()",
    meta: _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue")
  },
  {
    name: "presskit-slug___ar-AE",
    path: "/ar-AE/presskit/:slug()",
    meta: _91slug_93gcqbrBa1yct2wGuL29wSn3I0W7od8ys4lIgKXX9GSdMMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/[slug].vue")
  },
  {
    name: "media-kit-slug___en___default",
    path: "/media-kit/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue")
  },
  {
    name: "media-kit-slug___en",
    path: "/en/media-kit/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue")
  },
  {
    name: "media-kit-slug___pt-BR",
    path: "/pt-BR/media-kit/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue")
  },
  {
    name: "media-kit-slug___de",
    path: "/de/media-kit/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue")
  },
  {
    name: "media-kit-slug___es",
    path: "/es/media-kit/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue")
  },
  {
    name: "media-kit-slug___ro",
    path: "/ro/media-kit/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue")
  },
  {
    name: "media-kit-slug___ar-AE",
    path: "/ar-AE/media-kit/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/media-kit/[slug].vue")
  },
  {
    name: "press-kit-slug___en___default",
    path: "/press-kit/:slug()",
    meta: _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue")
  },
  {
    name: "press-kit-slug___en",
    path: "/en/press-kit/:slug()",
    meta: _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue")
  },
  {
    name: "press-kit-slug___pt-BR",
    path: "/pt-BR/press-kit/:slug()",
    meta: _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue")
  },
  {
    name: "press-kit-slug___de",
    path: "/de/press-kit/:slug()",
    meta: _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue")
  },
  {
    name: "press-kit-slug___es",
    path: "/es/press-kit/:slug()",
    meta: _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue")
  },
  {
    name: "press-kit-slug___ro",
    path: "/ro/press-kit/:slug()",
    meta: _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue")
  },
  {
    name: "press-kit-slug___ar-AE",
    path: "/ar-AE/press-kit/:slug()",
    meta: _91slug_93Kft_nYQSeJQyFPv5fNk_457OpHM_45xwUlGaIa1Y5UsLS4cMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/[slug].vue")
  },
  {
    name: "widget-wall-id___en___default",
    path: "/widget/wall/:id()",
    meta: _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue")
  },
  {
    name: "widget-wall-id___en",
    path: "/en/widget/wall/:id()",
    meta: _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue")
  },
  {
    name: "widget-wall-id___pt-BR",
    path: "/pt-BR/widget/wall/:id()",
    meta: _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue")
  },
  {
    name: "widget-wall-id___de",
    path: "/de/widget/wall/:id()",
    meta: _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue")
  },
  {
    name: "widget-wall-id___es",
    path: "/es/widget/wall/:id()",
    meta: _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue")
  },
  {
    name: "widget-wall-id___ro",
    path: "/ro/widget/wall/:id()",
    meta: _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue")
  },
  {
    name: "widget-wall-id___ar-AE",
    path: "/ar-AE/widget/wall/:id()",
    meta: _91id_93gq6KLE7s1WIL6q0lb2vdvivLYy3rXjkPkjq18oUtkBIMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/widget/wall/[id].vue")
  },
  {
    name: "password-recovery___en___default",
    path: "/password-recovery",
    meta: password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta || {},
    component: () => import("/app/pages/password-recovery.vue")
  },
  {
    name: "password-recovery___en",
    path: "/en/password-recovery",
    meta: password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta || {},
    component: () => import("/app/pages/password-recovery.vue")
  },
  {
    name: "password-recovery___pt-BR",
    path: "/pt-BR/password-recovery",
    meta: password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta || {},
    component: () => import("/app/pages/password-recovery.vue")
  },
  {
    name: "password-recovery___de",
    path: "/de/password-recovery",
    meta: password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta || {},
    component: () => import("/app/pages/password-recovery.vue")
  },
  {
    name: "password-recovery___es",
    path: "/es/password-recovery",
    meta: password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta || {},
    component: () => import("/app/pages/password-recovery.vue")
  },
  {
    name: "password-recovery___ro",
    path: "/ro/password-recovery",
    meta: password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta || {},
    component: () => import("/app/pages/password-recovery.vue")
  },
  {
    name: "password-recovery___ar-AE",
    path: "/ar-AE/password-recovery",
    meta: password_45recoveryxotdI1Ei_wxzu9EOgj3yEBFgHcz_45OFLVepxk2gcChrMMeta || {},
    component: () => import("/app/pages/password-recovery.vue")
  },
  {
    name: "wall-slug___en___default",
    path: "/wall/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue")
  },
  {
    name: "wall-slug___en",
    path: "/en/wall/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue")
  },
  {
    name: "wall-slug___pt-BR",
    path: "/pt-BR/wall/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue")
  },
  {
    name: "wall-slug___de",
    path: "/de/wall/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue")
  },
  {
    name: "wall-slug___es",
    path: "/es/wall/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue")
  },
  {
    name: "wall-slug___ro",
    path: "/ro/wall/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue")
  },
  {
    name: "wall-slug___ar-AE",
    path: "/ar-AE/wall/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/wall/[slug]/index.vue")
  },
  {
    name: "whats-new-preview___en___default",
    path: "/whats-new-preview",
    meta: whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue")
  },
  {
    name: "whats-new-preview___en",
    path: "/en/whats-new-preview",
    meta: whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue")
  },
  {
    name: "whats-new-preview___pt-BR",
    path: "/pt-BR/whats-new-preview",
    meta: whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue")
  },
  {
    name: "whats-new-preview___de",
    path: "/de/whats-new-preview",
    meta: whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue")
  },
  {
    name: "whats-new-preview___es",
    path: "/es/whats-new-preview",
    meta: whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue")
  },
  {
    name: "whats-new-preview___ro",
    path: "/ro/whats-new-preview",
    meta: whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue")
  },
  {
    name: "whats-new-preview___ar-AE",
    path: "/ar-AE/whats-new-preview",
    meta: whats_45new_45previewoDMzjfkbDpnjwuEg02eOIxto2UUgns1idy563No_qTgMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/whats-new-preview.vue")
  },
  {
    name: "mural-slug___en___default",
    path: "/mural/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue")
  },
  {
    name: "mural-slug___en",
    path: "/en/mural/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue")
  },
  {
    name: "mural-slug___pt-BR",
    path: "/pt-BR/mural/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue")
  },
  {
    name: "mural-slug___de",
    path: "/de/mural/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue")
  },
  {
    name: "mural-slug___es",
    path: "/es/mural/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue")
  },
  {
    name: "mural-slug___ro",
    path: "/ro/mural/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue")
  },
  {
    name: "mural-slug___ar-AE",
    path: "/ar-AE/mural/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/mural/[slug]/index.vue")
  },
  {
    name: "qa-sidebar-preview___en___default",
    path: "/qa-sidebar-preview",
    meta: qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta || {},
    component: () => import("/app/pages/qa-sidebar-preview.vue")
  },
  {
    name: "qa-sidebar-preview___en",
    path: "/en/qa-sidebar-preview",
    meta: qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta || {},
    component: () => import("/app/pages/qa-sidebar-preview.vue")
  },
  {
    name: "qa-sidebar-preview___pt-BR",
    path: "/pt-BR/qa-sidebar-preview",
    meta: qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta || {},
    component: () => import("/app/pages/qa-sidebar-preview.vue")
  },
  {
    name: "qa-sidebar-preview___de",
    path: "/de/qa-sidebar-preview",
    meta: qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta || {},
    component: () => import("/app/pages/qa-sidebar-preview.vue")
  },
  {
    name: "qa-sidebar-preview___es",
    path: "/es/qa-sidebar-preview",
    meta: qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta || {},
    component: () => import("/app/pages/qa-sidebar-preview.vue")
  },
  {
    name: "qa-sidebar-preview___ro",
    path: "/ro/qa-sidebar-preview",
    meta: qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta || {},
    component: () => import("/app/pages/qa-sidebar-preview.vue")
  },
  {
    name: "qa-sidebar-preview___ar-AE",
    path: "/ar-AE/qa-sidebar-preview",
    meta: qa_45sidebar_45previewZGig_45TdtHLYyOQDJEyl0xmvRkWMQ5_rs85JTScIgLS8Meta || {},
    component: () => import("/app/pages/qa-sidebar-preview.vue")
  },
  {
    name: "key-campaigns___en___default",
    path: "/key-campaigns",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue")
  },
  {
    name: "key-campaigns___en",
    path: "/en/key-campaigns",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue")
  },
  {
    name: "key-campaigns___pt-BR",
    path: "/pt-BR/key-campaigns",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue")
  },
  {
    name: "key-campaigns___de",
    path: "/de/key-campaigns",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue")
  },
  {
    name: "key-campaigns___es",
    path: "/es/key-campaigns",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue")
  },
  {
    name: "key-campaigns___ro",
    path: "/ro/key-campaigns",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue")
  },
  {
    name: "key-campaigns___ar-AE",
    path: "/ar-AE/key-campaigns",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/index.vue")
  },
  {
    name: "create-company___en___default",
    path: "/create-company",
    component: () => import("/app/pages/create-company/index.vue")
  },
  {
    name: "create-company___en",
    path: "/en/create-company",
    component: () => import("/app/pages/create-company/index.vue")
  },
  {
    name: "create-company___pt-BR",
    path: "/pt-BR/create-company",
    component: () => import("/app/pages/create-company/index.vue")
  },
  {
    name: "create-company___de",
    path: "/de/create-company",
    component: () => import("/app/pages/create-company/index.vue")
  },
  {
    name: "create-company___es",
    path: "/es/create-company",
    component: () => import("/app/pages/create-company/index.vue")
  },
  {
    name: "create-company___ro",
    path: "/ro/create-company",
    component: () => import("/app/pages/create-company/index.vue")
  },
  {
    name: "create-company___ar-AE",
    path: "/ar-AE/create-company",
    component: () => import("/app/pages/create-company/index.vue")
  },
  {
    name: "key-campaigns-slug___en___default",
    path: "/key-campaigns/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue")
  },
  {
    name: "key-campaigns-slug___en",
    path: "/en/key-campaigns/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue")
  },
  {
    name: "key-campaigns-slug___pt-BR",
    path: "/pt-BR/key-campaigns/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue")
  },
  {
    name: "key-campaigns-slug___de",
    path: "/de/key-campaigns/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue")
  },
  {
    name: "key-campaigns-slug___es",
    path: "/es/key-campaigns/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue")
  },
  {
    name: "key-campaigns-slug___ro",
    path: "/ro/key-campaigns/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue")
  },
  {
    name: "key-campaigns-slug___ar-AE",
    path: "/ar-AE/key-campaigns/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/[slug].vue")
  },
  {
    name: "presskit-game-slug___en___default",
    path: "/presskit/game/:slug()",
    meta: _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue")
  },
  {
    name: "presskit-game-slug___en",
    path: "/en/presskit/game/:slug()",
    meta: _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue")
  },
  {
    name: "presskit-game-slug___pt-BR",
    path: "/pt-BR/presskit/game/:slug()",
    meta: _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue")
  },
  {
    name: "presskit-game-slug___de",
    path: "/de/presskit/game/:slug()",
    meta: _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue")
  },
  {
    name: "presskit-game-slug___es",
    path: "/es/presskit/game/:slug()",
    meta: _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue")
  },
  {
    name: "presskit-game-slug___ro",
    path: "/ro/presskit/game/:slug()",
    meta: _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue")
  },
  {
    name: "presskit-game-slug___ar-AE",
    path: "/ar-AE/presskit/game/:slug()",
    meta: _91slug_93Zv58NNmMUg8HdrojkycPqhLEeqUSxOXngffLlVLql_45YMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/presskit/game/[slug].vue")
  },
  {
    name: "magazine-slug___en___default",
    path: "/magazine/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue")
  },
  {
    name: "magazine-slug___en",
    path: "/en/magazine/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue")
  },
  {
    name: "magazine-slug___pt-BR",
    path: "/pt-BR/magazine/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue")
  },
  {
    name: "magazine-slug___de",
    path: "/de/magazine/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue")
  },
  {
    name: "magazine-slug___es",
    path: "/es/magazine/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue")
  },
  {
    name: "magazine-slug___ro",
    path: "/ro/magazine/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue")
  },
  {
    name: "magazine-slug___ar-AE",
    path: "/ar-AE/magazine/:slug()",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/index.vue")
  },
  {
    name: "press-kit-game-slug___en___default",
    path: "/press-kit/game/:slug()",
    meta: _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue")
  },
  {
    name: "press-kit-game-slug___en",
    path: "/en/press-kit/game/:slug()",
    meta: _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue")
  },
  {
    name: "press-kit-game-slug___pt-BR",
    path: "/pt-BR/press-kit/game/:slug()",
    meta: _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue")
  },
  {
    name: "press-kit-game-slug___de",
    path: "/de/press-kit/game/:slug()",
    meta: _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue")
  },
  {
    name: "press-kit-game-slug___es",
    path: "/es/press-kit/game/:slug()",
    meta: _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue")
  },
  {
    name: "press-kit-game-slug___ro",
    path: "/ro/press-kit/game/:slug()",
    meta: _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue")
  },
  {
    name: "press-kit-game-slug___ar-AE",
    path: "/ar-AE/press-kit/game/:slug()",
    meta: _91slug_934J4aEVJBm5japDhgWKUpjjuxc92z4AqmVqNt3qSxEacMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/press-kit/game/[slug].vue")
  },
  {
    name: "esignature-sign-token___en___default",
    path: "/esignature/sign/:token()",
    component: () => import("/app/pages/esignature/sign/[token].vue")
  },
  {
    name: "esignature-sign-token___en",
    path: "/en/esignature/sign/:token()",
    component: () => import("/app/pages/esignature/sign/[token].vue")
  },
  {
    name: "esignature-sign-token___pt-BR",
    path: "/pt-BR/esignature/sign/:token()",
    component: () => import("/app/pages/esignature/sign/[token].vue")
  },
  {
    name: "esignature-sign-token___de",
    path: "/de/esignature/sign/:token()",
    component: () => import("/app/pages/esignature/sign/[token].vue")
  },
  {
    name: "esignature-sign-token___es",
    path: "/es/esignature/sign/:token()",
    component: () => import("/app/pages/esignature/sign/[token].vue")
  },
  {
    name: "esignature-sign-token___ro",
    path: "/ro/esignature/sign/:token()",
    component: () => import("/app/pages/esignature/sign/[token].vue")
  },
  {
    name: "esignature-sign-token___ar-AE",
    path: "/ar-AE/esignature/sign/:token()",
    component: () => import("/app/pages/esignature/sign/[token].vue")
  },
  {
    name: "magazine-slug-preview___en___default",
    path: "/magazine/:slug()/preview",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue")
  },
  {
    name: "magazine-slug-preview___en",
    path: "/en/magazine/:slug()/preview",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue")
  },
  {
    name: "magazine-slug-preview___pt-BR",
    path: "/pt-BR/magazine/:slug()/preview",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue")
  },
  {
    name: "magazine-slug-preview___de",
    path: "/de/magazine/:slug()/preview",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue")
  },
  {
    name: "magazine-slug-preview___es",
    path: "/es/magazine/:slug()/preview",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue")
  },
  {
    name: "magazine-slug-preview___ro",
    path: "/ro/magazine/:slug()/preview",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue")
  },
  {
    name: "magazine-slug-preview___ar-AE",
    path: "/ar-AE/magazine/:slug()/preview",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/magazine/[slug]/preview.vue")
  },
  {
    name: "key-campaigns-redeem-key___en___default",
    path: "/key-campaigns/redeem-key",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue")
  },
  {
    name: "key-campaigns-redeem-key___en",
    path: "/en/key-campaigns/redeem-key",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue")
  },
  {
    name: "key-campaigns-redeem-key___pt-BR",
    path: "/pt-BR/key-campaigns/redeem-key",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue")
  },
  {
    name: "key-campaigns-redeem-key___de",
    path: "/de/key-campaigns/redeem-key",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue")
  },
  {
    name: "key-campaigns-redeem-key___es",
    path: "/es/key-campaigns/redeem-key",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue")
  },
  {
    name: "key-campaigns-redeem-key___ro",
    path: "/ro/key-campaigns/redeem-key",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue")
  },
  {
    name: "key-campaigns-redeem-key___ar-AE",
    path: "/ar-AE/key-campaigns/redeem-key",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key.vue")
  },
  {
    name: "newsletter-manage-uuid___en___default",
    path: "/newsletter/manage/:uuid()",
    component: () => import("/app/pages/newsletter/manage/[uuid].vue")
  },
  {
    name: "newsletter-manage-uuid___en",
    path: "/en/newsletter/manage/:uuid()",
    component: () => import("/app/pages/newsletter/manage/[uuid].vue")
  },
  {
    name: "newsletter-manage-uuid___pt-BR",
    path: "/pt-BR/newsletter/manage/:uuid()",
    component: () => import("/app/pages/newsletter/manage/[uuid].vue")
  },
  {
    name: "newsletter-manage-uuid___de",
    path: "/de/newsletter/manage/:uuid()",
    component: () => import("/app/pages/newsletter/manage/[uuid].vue")
  },
  {
    name: "newsletter-manage-uuid___es",
    path: "/es/newsletter/manage/:uuid()",
    component: () => import("/app/pages/newsletter/manage/[uuid].vue")
  },
  {
    name: "newsletter-manage-uuid___ro",
    path: "/ro/newsletter/manage/:uuid()",
    component: () => import("/app/pages/newsletter/manage/[uuid].vue")
  },
  {
    name: "newsletter-manage-uuid___ar-AE",
    path: "/ar-AE/newsletter/manage/:uuid()",
    component: () => import("/app/pages/newsletter/manage/[uuid].vue")
  },
  {
    name: "key-campaigns-key-materials___en___default",
    path: "/key-campaigns/key-materials",
    meta: key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue")
  },
  {
    name: "key-campaigns-key-materials___en",
    path: "/en/key-campaigns/key-materials",
    meta: key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue")
  },
  {
    name: "key-campaigns-key-materials___pt-BR",
    path: "/pt-BR/key-campaigns/key-materials",
    meta: key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue")
  },
  {
    name: "key-campaigns-key-materials___de",
    path: "/de/key-campaigns/key-materials",
    meta: key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue")
  },
  {
    name: "key-campaigns-key-materials___es",
    path: "/es/key-campaigns/key-materials",
    meta: key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue")
  },
  {
    name: "key-campaigns-key-materials___ro",
    path: "/ro/key-campaigns/key-materials",
    meta: key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue")
  },
  {
    name: "key-campaigns-key-materials___ar-AE",
    path: "/ar-AE/key-campaigns/key-materials",
    meta: key_45materialshNV228U_45hjuN3L5LAxVCgJbJsokOS2CULDnFTK0jPFUMeta || {},
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/key-materials.vue")
  },
  {
    name: "key-campaigns-redeem-key-approved___en___default",
    path: "/key-campaigns/redeem-key-approved",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue")
  },
  {
    name: "key-campaigns-redeem-key-approved___en",
    path: "/en/key-campaigns/redeem-key-approved",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue")
  },
  {
    name: "key-campaigns-redeem-key-approved___pt-BR",
    path: "/pt-BR/key-campaigns/redeem-key-approved",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue")
  },
  {
    name: "key-campaigns-redeem-key-approved___de",
    path: "/de/key-campaigns/redeem-key-approved",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue")
  },
  {
    name: "key-campaigns-redeem-key-approved___es",
    path: "/es/key-campaigns/redeem-key-approved",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue")
  },
  {
    name: "key-campaigns-redeem-key-approved___ro",
    path: "/ro/key-campaigns/redeem-key-approved",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue")
  },
  {
    name: "key-campaigns-redeem-key-approved___ar-AE",
    path: "/ar-AE/key-campaigns/redeem-key-approved",
    component: () => import("/app/node_modules/@mundogamernetwork/shared-ui/pages/key-campaigns/redeem-key-approved.vue")
  },
  {
    name: "esignature-verify-verificationId___en___default",
    path: "/esignature/verify/:verificationId()",
    component: () => import("/app/pages/esignature/verify/[verificationId].vue")
  },
  {
    name: "esignature-verify-verificationId___en",
    path: "/en/esignature/verify/:verificationId()",
    component: () => import("/app/pages/esignature/verify/[verificationId].vue")
  },
  {
    name: "esignature-verify-verificationId___pt-BR",
    path: "/pt-BR/esignature/verify/:verificationId()",
    component: () => import("/app/pages/esignature/verify/[verificationId].vue")
  },
  {
    name: "esignature-verify-verificationId___de",
    path: "/de/esignature/verify/:verificationId()",
    component: () => import("/app/pages/esignature/verify/[verificationId].vue")
  },
  {
    name: "esignature-verify-verificationId___es",
    path: "/es/esignature/verify/:verificationId()",
    component: () => import("/app/pages/esignature/verify/[verificationId].vue")
  },
  {
    name: "esignature-verify-verificationId___ro",
    path: "/ro/esignature/verify/:verificationId()",
    component: () => import("/app/pages/esignature/verify/[verificationId].vue")
  },
  {
    name: "esignature-verify-verificationId___ar-AE",
    path: "/ar-AE/esignature/verify/:verificationId()",
    component: () => import("/app/pages/esignature/verify/[verificationId].vue")
  }
]